import React from 'react';
import * as Styled from './OBannerFeature.styles';
import { OBannerFeatureProps, OBannerFeatureLayout, OBannerFeatureContentAlignment } from './OBannerFeature.types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ABodyColor,
  ABodySize,
  AHeaderSize,
  AHeaderTag,
  AImage,
  MButton,
  MButtonSize,
  MTextBlockSimple,
  MTextBlockSimpleAlignment,
} from '@marriott/mi-web-ui-kit';
import { AspectRatio, MediaQuery, ResponsiveImageSpec, generateImageRenditions } from '../../utils/ImageUtils';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OBannerFeature';
const TEST_ID = 'mi-web-ui-kit-OBannerFeature';

const RESPONSIVE_IMAGE_SPECS: ResponsiveImageSpec[] = [
  {
    media: MediaQuery.MAX_WIDTH_SM,
    aspectRatio: AspectRatio.CLASSIC_HOR,
    imgWidthPx: 540,
  },
  {
    media: MediaQuery.MIN_WIDTH_MD,
    aspectRatio: AspectRatio.SQUARE,
    imgWidthPx: 360,
  },
  {
    media: MediaQuery.MIN_WIDTH_LG,
    aspectRatio: AspectRatio.CLASSIC_HOR,
    imgWidthPx: 560,
  },
  {
    media: MediaQuery.MIN_WIDTH_XL,
    aspectRatio: AspectRatio.CLASSIC_HOR,
    imgWidthPx: 665,
  },
];

export const OBannerFeature = ({
  contentAlignment = OBannerFeatureContentAlignment.Left,
  layout = OBannerFeatureLayout.Default,
  mTextBlockSimple,
  mButton,
  aImage,
}: OBannerFeatureProps) => {
  const eyebrowText = mTextBlockSimple?.aEyebrow?.eyebrowText;
  const headerText = mTextBlockSimple?.aHeader?.text;

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      layout={layout}
      className="container d-flex justify-content-center align-items-center"
    >
      {(layout === OBannerFeatureLayout.Default || layout === OBannerFeatureLayout.Reverse) && (
        <>
          <Styled.ContentSection contentAlignment={contentAlignment} className="">
            <Styled.TextBlockWrapper>
              <MTextBlockSimple
                {...(eyebrowText ? { eyebrowText } : {})}
                {...(headerText ? { headerText } : {})}
                headerSize={(mTextBlockSimple?.aHeader?.size as AHeaderSize) ?? AHeaderSize.TitleM}
                headerTag={(mTextBlockSimple?.aHeader?.headerTag as AHeaderTag) ?? AHeaderTag.h2}
                bodyText={mTextBlockSimple?.aBody?.bodyText ?? ''}
                bodySize={(mTextBlockSimple?.aBody?.size as ABodySize) ?? ABodySize.S}
                bodyColor={(mTextBlockSimple?.aBody?.color as ABodyColor) ?? ABodyColor.Default}
                alignment={
                  contentAlignment === OBannerFeatureContentAlignment.Center
                    ? MTextBlockSimpleAlignment.Center
                    : MTextBlockSimpleAlignment.Left
                }
              />
              {mButton?.ctaLink && mButton?.buttonText && (
                <Styled.ButtonWrapper contentAlignment={contentAlignment}>
                  <MButton
                    buttonText={mButton.buttonText}
                    variant={mButton.type}
                    size={MButtonSize.M}
                    href={mButton.ctaLink}
                    isExternal={mButton.openInANewTab === 'true'}
                  />
                </Styled.ButtonWrapper>
              )}
            </Styled.TextBlockWrapper>
          </Styled.ContentSection>
          <Styled.ImageSection className="col-12 col-md-6 col-lg-7 px-0">
            <AImage
              src={aImage?.image?.assetPath || ''}
              alt={aImage?.image?.altText || 'Banner Image'}
              renditions={generateImageRenditions(RESPONSIVE_IMAGE_SPECS, aImage?.image?.assetPath)}
              className="feature-image"
            />
          </Styled.ImageSection>
        </>
      )}
    </Styled.Wrapper>
  );
};

export { OBannerFeatureContentAlignment };
export type { OBannerFeatureProps, OBannerFeatureLayout };
